import {
  Component,
  DoCheck,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { CommentService } from "../../../../service/comment.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
declare var $: any;

import { Router } from "@angular/router";
import { environment } from "../../../../../environments/environment";

import * as _ from "lodash";
import { UserService } from "../../../../service/user.service";
import { eventEmitterService } from "../../../../service/eventEmitter.service";
import { PercentageIncreaseUpdaterService } from "../../../../service/percentage-increase-updater.service";
import { FeedService } from "../../../../service/feed.service";
import { Subject, Subscription } from "rxjs";

@Component({
  selector: "app-comments",
  templateUrl: "./comments.component.html",
  styleUrls: ["./comments.component.css"],
})
export class CommentsComponent implements OnInit, DoCheck, OnDestroy {
  @Input() activitiesId;
  @Input("commentId") commentId;
  @Input() feedType;
  @Input() isBuildingHasBuildingManager;

  id = localStorage.getItem("residents");
  isManager = localStorage.getItem("isManager");
  userBuildingId = localStorage.getItem("userBuildingId");
  userType = localStorage.getItem("type");
  commentData;
  commentsData: any = {};
  commentForm: FormGroup;
  editCommentForm: FormGroup;
  commentSubject = new Subject();
  timer: Subscription;

  environmentUrl = environment.apiUrl;

  oldCommentLength = 0;
  newCommentLength = 0;

  oldReplies = [];
  newReplies = [];
  flagCommentIDList = [];
  //isBuildingHasBuildingManager = false;
  isFieldEmpty = false;
  isEditFieldEmpty = false;
  s3apiUrl = environment.s3BucketApi;

  updatedReplyCount = [];

  // Partial loading vars
  isLoading = false;
  loadMore = true;

  constructor(
    private commentService: CommentService,
    private fb: FormBuilder,
    private ngZone: NgZone,
    private router: Router,
    private _feed: FeedService,
    private userService: UserService,
    private chatService: eventEmitterService,
    private percentageService: PercentageIncreaseUpdaterService
  ) {}

  ngOnInit() {
    this.chatService.replyCount$.subscribe((data) => {
      this.updatedReplyCount.push(data);
      //this.updatedReplyCount = data;

      setTimeout(() => {
        this.updatedReplyCount = this.updatedReplyCount.filter(
          (v, i, a) => i === a.findIndex((t) => t.id === v.id)
        );
        console.log(this.updatedReplyCount, "Updssss");
        this.commentData.forEach((val) => {
          if (this.updatedReplyCount.length > 0) {
            this.updatedReplyCount.forEach((comment) => {
              if (val.id === (comment.comment.id || comment.comment)) {
                if (comment.delete) {
                  val.repliesCount = comment.count;
                } else if (!comment.update) {
                  val.repliesCount = comment.commentData.repliesCount;
                }
              }
            });
          }
        });
        this.updatedReplyCount = [];
      }, 1000);
    });

    this._feed._feed$.subscribe((feedsRes) => {
      console.log({ feedsRes });
      if (feedsRes["comments"]) {
        // Get the activity ID from the appropriate field based on feed type
        let feedActivityId = feedsRes["comments"].activityFeed;

        // For maintenance, check the maintenance field
        if (
          this.feedType === "maintenance" &&
          feedsRes["comments"].maintenance
        ) {
          feedActivityId = feedsRes["comments"].maintenance;
        }

        // For events, check the event field
        if (this.feedType === "events" && feedsRes["comments"].event) {
          feedActivityId = feedsRes["comments"].event;
        }

        // Check if this comment belongs to the current activity
        if (this.activitiesId === feedActivityId) {
          if (feedsRes["comments"].delete) {
            this.commentData = this.commentData.filter((val) => {
              if (val.id === feedsRes["comments"].id) {
                return false;
              } else {
                return true;
              }
            });
            this.chatService.commentCount$.next(feedsRes["comments"]);
          } else if (feedsRes["comments"].updated) {
            // Update existing comment
            this.commentData.forEach((val) => {
              if (val.id === feedsRes["comments"].id) {
                val.content = feedsRes["comments"].content;
                val.isFlaggedBy = feedsRes["comments"].isFlaggedBy;
                val.votes = feedsRes["comments"].votes;
              }
            });
            if (feedsRes["comments"].flag) {
              this.chatService.commentCount$.next(feedsRes["comments"]);
            }
          } else {
            // New comment
            this.chatService.commentCount$.next(feedsRes["comments"]);
            this.commentData.unshift(feedsRes["comments"]);
          }
          this.commentData = this.commentData.filter(
            (v, i, a) => i === a.findIndex((t) => t.id === v.id)
          );
        }
      }
    });

    //console.log('Comment ID: ', + this.commentId)

    this.commentForm = this.fb.group({
      comment: ["", Validators.compose([Validators.required])],
    });

    this.editCommentForm = this.fb.group({
      comment: [
        "",
        Validators.compose([Validators.required, Validators.minLength(1)]),
      ],
    });

    //console.log('Comment activity ID : ', this.activitiesId);
    this.commentData = [];
    this.commentService
      .getCommentsByActivityFeed(this.activitiesId, this.id)
      .subscribe((comments) => {
        //console.log('Comments for Activity ID : ' + this.activitiesId, comments);
        this.commentData = comments;
        this.oldCommentLength = comments.length;
        for (let comment of comments) {
          this.oldReplies.push(comment.repliesCount);
          //console.log('comment.isFlaggedBy', comment);
        }

        if (comments.length <= 0) {
          this.loadMore = false;
        }
      });

    this.commentSubject.subscribe((comments) => {
      this.commentData = comments;
    });

    if (this.commentForm.valid) {
      this.isFieldEmpty = false;
    }

    // if(this.isManager != 'true'){
    //   this.userService.isManagerExists(this.userBuildingId).subscribe(
    //     (building) => {
    //       //console.log('Is Building Manager Exists : ', building);
    //       var buildingManager = building.building[0].buildingManager;
    //       var resident = building.building[0].resident;
    //       if(_.isEmpty(buildingManager) || _.isUndefined(buildingManager)){
    //         this.isBuildingHasBuildingManager = false;
    //       }else {
    //         this.isBuildingHasBuildingManager = true;
    //       }
    //     }
    //   );
    // }

    this.commentService
      .getFlaggedCommentByUserId(this.id)
      .subscribe((comments) => {
        //console.log('Comments Flagged : ', comments);
        for (let comment of comments.comments) {
          if (comment.isFlaggedBy.length > 0) {
            this.flagCommentIDList.push(comment.id);
          }
        }
        //console.log('Comment flagged ID list', this.flagCommentIDList);
      });
  }

  ngOnDestroy() {
    if (this.timer) {
      this.timer.unsubscribe();
    }
  }

  openChat(user) {
    this.chatService.open(user);
  }

  showContent(event) {
    $(event).find("div.showmoredrp").toggle();
  }

  flagPostToggle(commentId, ele, flagType) {
    //$(ele).find('span').toggle();

    let type;
    if (
      this.feedType == "post" ||
      this.feedType == "group" ||
      this.feedType == "recommendation" ||
      this.feedType == "marketplace"
    ) {
      type = "Activityfeed";
    } else if (this.feedType == "maintenance") {
      type = "Maintanance";
    } else if (this.feedType == "events") {
      type = "Events";
    }

    this.commentService
      .flagCommentById(
        commentId,
        this.id,
        type,
        this.isManager,
        flagType,
        this.activitiesId
      )
      .subscribe((flag) => {
        //console.log('Flagged comment : ', flag);
        // this.commentService.getFlaggedCommentByUserId(this.id).subscribe(
        //   (comments) => {
        //     //console.log('Comments Flagged : ', comments);
        //     this.flagCommentIDList = [];
        //     for(let comment of comments.comments){
        //       if(comment.isFlaggedBy.length > 0){
        //         this.flagCommentIDList.push(comment.id);
        //       }
        //     }
        //     //console.log('Comment flagged ID list', this.flagCommentIDList);
        //   }
        // );
      });
  }

  showTextField(event, content, commentId) {
    //console.log('Element: ' , event);
    $(event).parents(".feed_commented_text").find("input#editcomment").show();
    $("#editcomment_" + commentId).show();
    $(event).parents(".feed_commented_text").find("span.close-icon").show();
  }

  hideTextField(element, commentId, content) {
    //console.log(element);
    $("#editcomment_" + commentId).val(content);
    $("#editcomment_" + commentId).hide();
    $(element).parents(".feed_commented_text").find("input#editcomment").hide();
    $(element).parents(".feed_commented_text").find("span.close-icon").hide();
  }

  onCommentSubmit(activityId) {
    if (activityId) {
      const formData = this.commentForm.value;
      //console.log(formData, activityId);
      let type;

      //console.log('Comment valid  : ',this.commentForm.valid);

      if (!this.commentForm.valid) {
        this.isFieldEmpty = true;
      }

      if (
        _.isEmpty(formData.comment.trim()) ||
        _.isUndefined(formData.comment.trim())
      ) {
        this.isFieldEmpty = true;
      } else {
        this.commentForm.reset();
        this.commentsData = {
          content: formData.comment,
          activityFeed: activityId,
          commentedBy: this.id,
        };

        if (
          this.feedType == "post" ||
          this.feedType == "group" ||
          this.feedType == "recommendation" ||
          this.feedType == "marketplace"
        ) {
          type = "Activityfeed";
        } else if (this.feedType == "maintenance") {
          type = "Maintanance";
          this.commentsData.maintenance = activityId;
        } else if (this.feedType == "events") {
          this.commentsData.event = activityId;
          type = "Events";
        }
        //console.log(this.commentsData, 'comment datatata')
        this.commentService
          .saveComment(this.commentsData, type)
          .subscribe((response) => {
            var responseObj = JSON.parse(JSON.stringify(response));
            //console.log(responseObj._body);
            this.percentageService
              .getUpdatedFeed(this.activitiesId, this.feedType, false)
              .subscribe((res) => {});
          });
      }
    }
  }

  onEditComment(commentId, content, element, cl) {
    let type;
    if (
      this.feedType == "post" ||
      this.feedType == "group" ||
      this.feedType == "recommendation" ||
      this.feedType == "marketplace"
    ) {
      type = "Activityfeed";
    } else if (this.feedType == "maintenance") {
      type = "Maintanance";
    } else if (this.feedType == "events") {
      type = "Events";
    }

    if (
      this.editCommentForm.valid &&
      content != this.editCommentForm.value.comment &&
      this.editCommentForm.get("comment").value.trim().length > 0
    ) {
      $("#editcomment_" + commentId).removeClass("error comment-error");
      this.isEditFieldEmpty = false;
      var commentData = {
        id: commentId,
        content: this.editCommentForm.value.comment,
      };

      this.commentService
        .updateComment(commentData, type)
        .subscribe((comment) => {
          if (comment) {
            this.hideTextField(cl, commentId, content);
            // this.commentService.getCommentsByActivityFeed(this.activitiesId, this.id).subscribe(
            //   (comments) => {
            //     this.commentSubject.next(comments);
            //     this.commentForm.reset();
            //   }
            // );
          }
        });
    } else {
      this.isEditFieldEmpty = true;
      if (this.editCommentForm.get("comment").value.trim().length <= 0) {
        $("#editcomment_" + commentId).val("");
        $("#editcomment_" + commentId).attr("placeholder", "Enter a comment");
        $("#editcomment_" + commentId).addClass("error comment-error");
      }
    }
  }

  onDeleteComment(commentId) {
    let type;
    if (
      this.feedType == "post" ||
      this.feedType == "group" ||
      this.feedType == "recommendation" ||
      this.feedType == "marketplace"
    ) {
      type = "Activityfeed";
    } else if (this.feedType == "maintenance") {
      type = "Maintanance";
    } else if (this.feedType == "events") {
      type = "Events";
    }
    this.commentData = this.commentData.filter((val) => val.id !== commentId);
    // console.log('Comment ID to delete : ' , commentId);
    this.commentService
      .deleteComment(
        commentId,
        type,
        this.id,
        this.activitiesId,
        this.isManager
      )
      .subscribe((deleted) => {
        if (deleted.success) {
          this.commentService
            .getCommentsByActivityFeed(this.activitiesId, this.id)
            .subscribe((comments) => {
              //  this.commentSubject.next(comments);
              //  this.commentForm.reset();
            });
        }
      });
  }

  onCommentFieldClick() {
    this.isFieldEmpty = false;
  }
  userUpvote(commentsId) {
    //console.log(this.feedType,this.activitiesId, "feed type in upvote method");
    let type;
    if (
      this.feedType == "post" ||
      this.feedType == "group" ||
      this.feedType == "recommendation" ||
      this.feedType == "marketplace"
    ) {
      type = "Activityfeed";
    } else if (this.feedType == "maintenance") {
      type = "Maintanance";
    } else if (this.feedType == "events") {
      type = "Events";
    }

    this.commentService
      .commentsLikes(commentsId, type, this.activitiesId)
      .subscribe((res) => {
        //console.log(res);
        this.commentService
          .getCommentsByActivityFeed(this.activitiesId, this.id)
          .subscribe((comments) => {
            //  this.commentSubject.next(comments);
            //  this.commentForm.reset();
            this.percentageService
              .getUpdatedFeed(this.activitiesId, this.feedType, false)
              .subscribe((res) => {});
          });
      });
  }

  ngDoCheck() {}

  arrDiff(a1, a2) {
    return a1.concat(a2).filter(function (val, index, arr) {
      return arr.indexOf(val) === arr.lastIndexOf(val);
    });
  }

  loadAllComments(activityId) {
    this.isLoading = true;
    this.commentService
      .getAllCommentsByActivityFeed(activityId, this.id)
      .subscribe((comments) => {
        //console.log('Comments Data : ', comments);
        this.commentData = comments;
        this.loadMore = false;
        this.isLoading = false;
      });
  }
}
